/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPayments} from '../api'

 export const useQueryGetPayments = createReactQueryHook('getPayments', getPayments)
